import UnderDevelopment from 'components/Global/UnderDevelopment';

const Tour = () => {
  return <UnderDevelopment />;
};

export default Tour;
